module.exports = __webpack_public_path__ + "img/HA1505-169.407dd036.jpg";